/**
 * Author:XCL
 *
 * Time:2016-01-24
 */
'use strict';
angular.module('resourceCenterXhsgBigdataDetailModule', []).controller('resourceCenterXhsgBigdataDetailCtrl', [
    '$scope',
    '$timeout',
    '$state',
    '$location',
    '$q',
    '$sce',
    '$stateParams',
    '$window',
    'trsHttpService',
    'modalDialog',
    'resCtrModalService',
    'storageListenerService',
    'trsPrintService',
    'ueditorService',
    'localStorageService',
    'xinhuaApiService',
    function(
        $scope,
        $timeout,
        $state,
        $location,
        $q,
        $sce,
        $stateParams,
        $window,
        trsHttpService,
        modalDialog,
        resCtrModalService,
        storageListenerService,
        trsPrintService,
        ueditorService,
        localStorageService,
        xinhuaApiService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'xhsg',
                modelid: 'detailData',
                guid: $stateParams.guid,
                channelName: 'xhsg',
                typeid: 'zyzx',
                indexName: $stateParams.indexname,
            };
            $scope.doctype = $stateParams.type;
            $scope.paramForWCM = $scope.doctype === '新闻' ? xinhuaApiService.getNewsDetailParams() : xinhuaApiService.getPicDocDetailParams();
            $scope.paramForWCM.XHSGSourceId = $stateParams.docid;
            $scope.status = {
                listOpen: 'processView', // 默认选中的属性信息
                comefrom: 'source.xinhuadoc',
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: true, // 作者信息
                    draftRelatedInfo: true, // 稿件关联信息
                    relevantDraft: true, // 相关稿件
                    groupReprint: true, // 集团转载
                    relatedHotwords: true, // 关联热点词
                    reprintMedia: true, // 转载媒体
                },
                isShowRelated: true, // 根据要求显示右侧
            };
            $scope.data = {
                // keywordsArray: [], //关键词数组
                tenantInfo: '', // 租户信息
                // 本媒体取签流程数据
                groupProcess: {
                    // 集团取签流程
                    medias: [
                        {
                            MEDIANAME: '全部'
                        },
                    ], // 媒体列表
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                    process: [], // 取签流程
                    selectedMedia: '', // 选中的产品
                    progressData: [],
                },
                // 稿件实体信息
                groupEntityInfo: {
                    GJINFO_TYPE: 'xhsg',
                    tagArray: [],
                },
                authorInfo: {
                    // 作者信息
                    authorList: [
                        {
                            // 作者信息列表
                            COMPANY: '浙报集团',
                            DEPT: 'TRS',
                            USERNAME: '何志恺特殊小号部队1号',
                        },
                    ],
                },
                draftRelatedInfo: {
                    // 稿件关联信息
                    relatedInfo: [
                        {
                            // 关联信息分类
                            name: '关联领导人',
                            value: '',
                        },
                        {
                            name: '关联机构',
                            value: '1',
                        },
                        {
                            name: '关联地域',
                            value: '2',
                        },
                    ],
                    selectedRelatedInfo: '', // 选中的关联信息分类
                    relatedLeaders: [], // 关联领导人
                    relatedOrganizations: [], // 关联机构
                    relatedAreas: [], // 关联地域
                },
                relevantDraft: {
                    // 相关稿件
                    page: {
                        // 相关稿件分页
                        CURRPAGE: 1,
                        PAGESIZE: 10,
                    },
                    draftList: [], // 相关稿件列表
                },
                groupReprint: {
                    // 集团转载
                    reprintList: [],
                },
                relatedHotwords: {
                    // 关联热点词
                    hotwordsList: [],
                },
                tags: [], // 标签
                picList: [],
            };
            $scope.basicParams = {
                channelName: 'xhsg',
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.doctype === '新闻') {
                $scope.loadingPromise = xinhuaApiService.getNewsDetail($scope.paramForWCM).then(function(data) {
                    dealSuccessData(data);
                });
            } else {
                $scope.loadingPromise = xinhuaApiService.getNewsDetail($scope.paramForWCM).then(function(data) {
                    dealSuccessData(data);
                });
            }
        }

        /**
         * [dealSuccessData 处理成功返回后的数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealSuccessData(data) {
            $scope.detailInfos = data;
            $scope.detailInfos.content = data && $sce.trustAsHtml($scope.detailInfos.content);
            $scope.keywords = data.keywords === '' ? [] : data.keywords.split('-');
            $scope.data.tags = !data.tags ? [] : data.tags.split(',');
            if ($scope.detailInfos.imgList.length) {
                $scope.detailInfos.imgList.forEach(function(item, index) {
                    let check = false;
                    if (index === 0) {
                        check = true;
                    }
                    $scope.data.picList.push({
                        PERPICURL: item.PERPICURL,
                        active: check,
                        APPDESC: '',
                    });
                });
            }
            loadRightPanel();
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            let pageTurningData;
            pageTurningData = localStorageService.get('xhDetailTurning');
            if (typeof pageTurningData === 'string') {
                pageTurningData = JSON.parse(pageTurningData);
            }
            let currentId = $stateParams.docid;
            let toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].id === currentId) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go('resourcexhsgbigdatadetail', { docid: toPageData.id, type: toPageData.doctype }, {
                reload: true
            });
        };

        /**
         * [contentResize description] 设置左右侧高度一样
         * @return {[type]} [description]
         */
        $scope.contentResize = function() {
            $timeout(function() {
                var $father = $('.resource_detail');
                var $left = $father.find('.resource_detail_article');
                var $right = $father.find('.resource_detail_relatedInfo');
                var leftHeight = $left.height();
                $right.height(leftHeight);
                $left.resize(function(event) {
                    var leftHeight = $left.height();
                    $right.height(leftHeight);
                });
            });
        };

        /**
         * [openTakeDraftModal description] 取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = xinhuaApiService.getFetchParams();
            params.XHSGSourceIds = $stateParams.docid;
            $scope.detailInfos.DOCTYPE = $scope.detailInfos.doctypeId;
            var modalInstance = resCtrModalService.fullTakeDraft(params, false, [$scope.detailInfos]);
            modalInstance.result.then(
                function(data) {
                    storageListenerService.addListenerToResource('takeDraft');
                    // initData();
                    loadRightPanel();
                },
                function() {
                    storageListenerService.addListenerToResource('takeDraft');
                    // initData();
                    loadRightPanel();
                }
            );
        };

        /* 稿件操作结束*/

        /** 右侧关联信息面板数据加载 */

        /**
         * [loadRightPanel 加载右侧信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadRightPanel() {
            loadOperFlagList();
            loadDocInfo();
            loadRelatedInfos();
            loadRepintInfo();
            loadRelatedHotwords();
        }

        /**
         * [loadOperFlagList 加载本媒体取签流程]
         *
         * @return  {[type]}  [return description]
         */
        function loadOperFlagList() {
            let params = xinhuaApiService.getFlagListParams();
            params.XHSGSourceId = $state.params.docid;
            xinhuaApiService.getFlagList(params).then(function(data) {
                dealOperListData(data);
            });
        }

        /**
         * [dealOperListData 处理本媒体取签记录数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealOperListData(data) {
            if (data.QU && data.QU.length) {
                setOperFlagMedia(data.QU);
            }
            if (data.QIAN && data.QIAN.length) {
                setOperFlagMedia(data.QIAN);
            }
            if (data.JIAN && data.JIAN.length) {
                setOperFlagMedia(data.JIAN);
            }
            if (data.CHE && data.CHE.length) {
                setOperFlagMedia(data.CHE);
            }
            if (data.CHONG && data.CHONG.length) {
                setOperFlagMedia(data.CHONG);
            }
            $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
        }

        /**
         * [setOperFlagMedia 设置本媒体取签的媒体列表]
         *
         * @param   {[type]}  data  [data 取签见撤记录]
         *
         * @return  {[type]}        [return description]
         */
        function setOperFlagMedia(data){
            data.forEach((item) => {
                var media = {
                    MEDIANAME: item.MEDIANAME
                };
                if (mediaNotExsit(media)){
                    $scope.data.groupProcess.medias.push(media);
                }
                $scope.data.groupProcess.process.push(item);
                $scope.data.groupProcess.progressData.push(item);
            });
        }

        /**
         * [mediaNotExsit 判断取签见撤媒体列表中是否已经存在目标媒体]
         *
         * @param   {[type]}  media  [media 目标媒体]
         *
         * @return  {[type]}         [return description]
         */
        function mediaNotExsit(media) {
            return JSON.stringify($scope.data.groupProcess.medias).indexOf(media.MEDIANAME) === -1;
        }

        $scope.selectQqjccChannel = function(media){
            $scope.data.groupProcess.selectedMedia = media;
            if (media.MEDIANAME === '全部') {
                $scope.data.groupProcess.process = $scope.data.groupProcess.progressData;
            } else {
                $scope.data.groupProcess.process = $scope.data.groupProcess.progressData.filter((item) => item.MEDIANAME === media.MEDIANAME);
            }
        };

        /**
         * [loadDocInfo 加载稿件信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadDocInfo() {
            $scope.data.groupEntityInfo.tagArray = $scope.data.tags;
            $scope.data.groupEntityInfo.ZK = $scope.detailInfos.sourceUrl;
        }

        /**
         * [loadRelatedInfos 加载关联信息]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function loadRelatedInfos(params) {}

        /**
         * [loadRepintInfo 加载内部分析]
         *
         * @return  {[type]}  [return description]
         */
        function loadRepintInfo() {}

        /**
         * [loadRelatedHotwords 加载传播分析]
         *
         * @return  {[type]}  [return description]
         */
        function loadRelatedHotwords() {}

        /** 右侧关联信息面板数据加载结束 */
    },
]);
